export default "__VITE_ASSET__WO6mDbde__"